import { createSlice } from "@reduxjs/toolkit";

export interface TranscludeState {
  showCopy: boolean;
  showEmphasis: boolean;
}

const initialState: TranscludeState = {
  showCopy: false,
  showEmphasis: true,
};

export const transcludeSlice = createSlice({
  name: "transclude",
  initialState,
  reducers: {
    toggleShowCopy: (state) => {
      state.showCopy = !state.showCopy;
    },
    toggleShowEmphasis: (state) => {
      state.showEmphasis = !state.showEmphasis;
    },
  },
});

export const { toggleShowCopy, toggleShowEmphasis } = transcludeSlice.actions;

export default transcludeSlice.reducer;
